import React from "react";
import "./Button.css";

const Button = ({
  text,
  size = "regular",
  color = "default",
  onClick,
  disabled = false,
  className = "",
  href,
  ...rest
}) => {
  let sizeClass = "";
  if (size === "long") sizeClass = "btn-long";
  else if (size === "discord") sizeClass = "btn-discord";
  else sizeClass = "btn-regular";

  const colorClass = color === "black" ? "btn-black" : "";

  const combinedClassName = `btn ${sizeClass} ${colorClass} ${className}`;

  // If it's a link, render <a> styled like a button
  if (href) {
    return (
      <a
        className={combinedClassName}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        {...rest}
      >
        {text}
      </a>
    );
  }

  return (
    <button
      className={`btn ${sizeClass} ${colorClass} ${className} btn-font`}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {text}
    </button>
  );
};

export default Button;
